import Raven from 'raven-js';
import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { trackContentAccessControlModalPanelSave } from 'ui-memberships-settings-lib/utils/tracking';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { CHANGED_CONTENT_ACCESS } from '../actions/ActionTypes';
import { receiveContent, requestChangeContentAccess, requestedChangeContentAccessFailure, requestedChangeContentAccessSuccess, requestedContentFailed, requestContent // @ts-expect-error untyped module
} from '../actions/ContentActions'; // @ts-expect-error untyped module

import { closeModal } from '../actions/ModalActions';
import { ContentTypeToContentId } from '../constants/base';

const changeContentAccessEpic = (action$, _, {
  ContentClient
}) => action$.ofType(CHANGED_CONTENT_ACCESS).pipe(mergeMap(({
  payload
}) => {
  const {
    audienceAccessOptions,
    contentId,
    contentType
  } = payload;
  return ContentClient.changeContentAccess(contentType, contentId, audienceAccessOptions).pipe(mergeMap(() => ContentClient.fetchContent({
    contentPageId: contentId,
    contentType
  }).pipe(mergeMap(content => {
    const contentCategoryId = ContentTypeToContentId[contentType];
    const publicAccessRuleType = audienceAccessOptions.publicAccessRules.length ? audienceAccessOptions.publicAccessRules[0].type : PublicAccessRuleTypes.PUBLIC;
    trackContentAccessControlModalPanelSave({
      contentCategoryId,
      contentCount: 1,
      publicAccessRuleType
    });
    return of(receiveContent(content), closeModal(), requestedChangeContentAccessSuccess({
      contentCategoryId,
      publicAccessRuleType
    }));
  }), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()))), catchError(error => {
    Raven.captureMessage('Change content access request failed in changeContentAccess() action epic', {
      extra: {
        error
      }
    });
    const contentCategoryId = ContentTypeToContentId[contentType];
    return of(requestedChangeContentAccessFailure({
      contentCategoryId
    }));
  }), startWith(requestChangeContentAccess()));
}));

export default changeContentAccessEpic;